import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faHome, faSortAmountDown, faLightbulb, faFlask, faTrashAlt, faLemon } from '@fortawesome/free-solid-svg-icons';
import {
    Link
  } from "react-router-dom"
import Utilities from '../../../js/Utilities';
import './ReportsHeader.css';
import { useAuthState } from '../../../js/firebase';
import { getAuth, signOut } from 'firebase/auth';

function HeaderButton(props){
    return <Link className='headerBtn' to={props.to}> 
    <FontAwesomeIcon className='btnIcon' icon={props.icon} size='2x'/>
</Link>
  }

function ReportsHeader(props){
    const { user, isAuthenticated, userRole } = useAuthState();

    // Check if user is authorized (only allow specific domains)
    if(user && !user.email.endsWith("@gottea.in") && !user.email.endsWith("@bluetokaicoffee.com") && user.email !== "raj279@gmail.com"){
        signOut(getAuth());
    }

    return <React.Fragment><div className="headerContainer">
        
    <HeaderButton to={'/'} icon={faHome}/>
    {userRole === 'admin' && (
        <>
            <HeaderButton to={'/ai-helper'} icon={faLightbulb}/>
            <HeaderButton to={'/ingredients-recipes'} icon={faFlask}/>
        </>
    )}
    <HeaderButton to={'/recipe-wastage'} icon={faTrashAlt}/>
    <HeaderButton to={'/mango-pickle-stock'} icon={faLemon}/>
    {/* <HeaderButton to={'/consumption-prediction'} icon={faChartLine}/> */}
    {/* <HeaderButton to={'/consumption'} icon={faSortAmountDown}/> */}
    {/* <HeaderButton to={'/announcement'} icon={faScroll}/> */}
    {/* <HeaderButton to={'/customers'} icon={faUsers}/> */}
    {/* <HeaderButton to={'/hourwisesales'} icon={faChartBar}/> */}
    {/* <HeaderButton to={'/croffles'} icon={faUtensils}/> */}
    <div className="welcomeMsg">
        {user?.displayName || 'Welcome'}
    </div>
    <div className='headerBtn logOutBtn' onClick={Utilities.logout}> 
        <FontAwesomeIcon className='btnIcon' icon={faSignOutAlt} size='2x'/>
        Log Out
    </div>
</div>

</React.Fragment>

}

export default ReportsHeader;
